function c(r) {
  return (n) => u(n, r);
}
function e(r) {
  return (n) => r === n ? !0 : u(n, r._id) || u(n, r._clientId);
}
function u(r, n) {
  return r._id != null && r._id === n || r._clientId != null && r._clientId === n;
}
export {
  e as byIdentifiable,
  c as byIdentifier,
  u as entityMatchesIdentifier
};
